// node_modules/@jspm/core/nodelibs/browser/http2.js
function unimplemented(name) {
  throw new Error(
    `Node.js HTTP/2 ${name} is not currently supported by JSPM core in Deno`
  );
}
var Http2Session = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
var ServerHttp2Session = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
var ClientHttp2Session = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
var Http2Stream = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
var ClientHttp2Stream = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
var ServerHttp2Stream = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
var Http2Server = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
var Http2SecureServer = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
function createServer() {
}
function createSecureServer() {
}
function connect() {
}
var constants = {};
function getDefaultSettings() {
}
function getPackedSettings() {
}
function getUnpackedSettings() {
}
var sensitiveHeaders = /* @__PURE__ */ Symbol("nodejs.http2.sensitiveHeaders");
var Http2ServerRequest = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
var Http2ServerResponse = class {
  constructor() {
    unimplemented(this.constructor.name);
  }
};
var http2 = {
  Http2Session,
  ServerHttp2Session,
  ClientHttp2Session,
  Http2Stream,
  ClientHttp2Stream,
  ServerHttp2Stream,
  Http2Server,
  Http2SecureServer,
  createServer,
  createSecureServer,
  connect,
  constants,
  getDefaultSettings,
  getPackedSettings,
  getUnpackedSettings,
  sensitiveHeaders,
  Http2ServerRequest,
  Http2ServerResponse
};
export {
  ClientHttp2Session,
  ClientHttp2Stream,
  Http2SecureServer,
  Http2Server,
  Http2ServerRequest,
  Http2ServerResponse,
  Http2Session,
  Http2Stream,
  ServerHttp2Session,
  ServerHttp2Stream,
  connect,
  constants,
  createSecureServer,
  createServer,
  http2 as default,
  getDefaultSettings,
  getPackedSettings,
  getUnpackedSettings,
  sensitiveHeaders
};
